var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import TextInput from '../TextInput/TextInput';
import { Container, EmptyOption, Option, OptionLabel } from './DropdownInput.styled';
import { Icon } from '..';
import Tether from '../Tether/Tether';
function DropdownInput(_a) {
    var _b, _c;
    var options = _a.options, onSelect = _a.onSelect, onChange = _a.onChange, _value = _a.value, _d = _a.closeOnChange, closeOnChange = _d === void 0 ? true : _d, _e = _a.disableInternalSearch, disableInternalSearch = _e === void 0 ? false : _e, _f = _a.onClickOutside, onClickOutside = _f === void 0 ? function () { return undefined; } : _f, rest = __rest(_a, ["options", "onSelect", "onChange", "value", "closeOnChange", "disableInternalSearch", "onClickOutside"]);
    var defaultOption = { label: '', value: '' };
    var _g = useState(_value), value = _g[0], setValue = _g[1];
    var _h = useState(false), menuOpen = _h[0], setMenuOpen = _h[1];
    useEffect(function () {
        setValue(_value);
    }, [_value]);
    var currentOption = (_b = options.find(function (opt) { return opt.value === value; })) !== null && _b !== void 0 ? _b : defaultOption;
    var _j = useState(currentOption.label), search = _j[0], setSearch = _j[1];
    var inputRef = useRef(null);
    var containerRef = useRef(null);
    var filteredOptions = disableInternalSearch
        ? options
        : options.filter(function (option) {
            return option.label.toLowerCase().includes(search.toLowerCase());
        });
    var handleChange = function (search) {
        onChange(search);
        setSearch(search);
    };
    var handleSelect = function (opt) {
        if (closeOnChange) {
            setMenuOpen(false);
        }
        if (currentOption.value === opt.value) {
            onSelect('');
            setValue('');
            setSearch('');
            return;
        }
        onSelect(opt.value);
        setValue(opt.value);
        setSearch(opt.label);
    };
    // // when we click outside of the menu container we should close the menu
    // useClickOutside(containerRef, () => {
    //   onClickOutside?.();
    //   setMenuOpen(false);
    // });
    return (React.createElement("div", { style: { position: 'relative' }, ref: containerRef },
        React.createElement("div", { ref: inputRef },
            React.createElement(TextInput, __assign({ value: menuOpen ? search : currentOption.label, onChange: function (e) { return handleChange(e.target.value); }, onFocus: function () { return setMenuOpen(true); } }, rest))),
        React.createElement(Tether, { target: inputRef, align: "bottom", show: menuOpen, offset: { horizontal: 0, vertical: 0 }, onClose: function () {
                onClickOutside();
                setMenuOpen(false);
            } },
            React.createElement(Container, { style: {
                    width: (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width,
                } }, filteredOptions.length > 0 ? (filteredOptions.map(function (option) { return (React.createElement(Option, { key: option.value, onClick: function () { return handleSelect(option); } },
                React.createElement(OptionLabel, null, option.label),
                currentOption.value === option.value ? (React.createElement(Icon, { name: "check", color: "success" })) : (React.createElement("div", { style: { width: 16, height: 16 } })))); })) : (React.createElement(EmptyOption, null, "No items found"))))));
}
export default DropdownInput;
